<div class="certificate-final-provision flex flex-col gap-6"
     [formGroup]="form()"
>
  <div class="comparison-grid expanded-mode"
       data-test="certificate-final-provision-comparison-grid"
  >

    <div class="flex flex-col gap-2">
      <albert-input-wrapper *albertIfCategory="'exclusionLiability'; config: visibility"
                            data-test="wrapper-certificate-final-provisions-exclusion-liability"
                            groupName="exclusionLiability"
                            tooltipLabel="Exclusion Liability"
                            [disabled]="!canEdit()"
      >
        <albert-select controlName="exclusionLiability"
                       data-test="certificate-final-provisions-exclusion-liability"
                       inputId="exclusionLiability"
                       label="Exclusion Liability"
                       [disabled]="!canEdit()"
                       [options]="exclusionLiabilityOptions"
        />
      </albert-input-wrapper>
      <albert-freetext-section *albertIfCategory="'exclNeglWilfulMisconduct'; config: visibility"
                               dataTestPrefix="certificate-final-provisions"
                               [form]="form()"
                               [section]="freetextSectionsByKey.exclNeglWilfulMisconduct"
      />
    </div>
    <div class="override-cell flex flex-col gap-2">
      <albert-checkbox *albertIfCategory="'exclusionWorkmensCompensation'; config: visibility"
                       controlName="exclusionWorkmensCompensation"
                       data-test="certificate-final-provisions-exclusion-workmens-compensation"
                       groupName="exclusionWorkmensCompensation"
                       inputId="exclusionWorkmensCompensation"
                       label="exclusion Workmen's compensation"
                       [disabled]="!canEdit()"
      />
      <albert-freetext-section *albertIfCategory="'freetext'; config: visibility"
                               dataTestPrefix="certificate-final-provisions"
                               [form]="form()"
                               [section]="freetextSectionsByKey.freetext"
      />
    </div>
    <div class="flex flex-col gap-2">
      <albert-checkbox *albertIfCategory="'airBrokerIncluded'; config: visibility"
                       controlName="airBrokerIncluded"
                       data-test="certificate-final-provisions-air-broker-included"
                       groupName="airBrokerIncluded"
                       inputId="airBrokerIncluded"
                       label="Air Broker included"
                       [disabled]="!canEdit()"
      />
      <albert-input-wrapper *albertIfCategory="'airBrokerName'; config: visibility"
                            data-test="wrapper-certificate-final-provisions-air-broker-name"
                            groupName="airBrokerName"
                            tooltipLabel="Air Broker Name"
                            [disabled]="!canEdit()"
      >
        <albert-input controlName="airBrokerName"
                      data-test="certificate-final-provisions-air-broker-name"
                      groupName="airBrokerName"
                      inputId="airBrokerName"
                      label="Air Broker Name"
                      [disabled]="!canEdit() || !form().controls.airBrokerIncluded.value"
                      [required]="true"

        />
      </albert-input-wrapper>
      <albert-checkbox *albertIfCategory="'boeingDefinition'; config: visibility"
                       controlName="boeingDefinition"
                       data-test="certificate-final-provisions-boeing-definition"
                       groupName="boeingDefinition"
                       inputId="boeingDefinition"
                       label="Boeing Definition"
                       [disabled]="!canEdit()"
      />
      <albert-checkbox *albertIfCategory="'exclusionManufacturerRepairer'; config: visibility"
                       controlName="exclusionManufacturerRepairer"
                       data-test="certificate-final-provisions-exclusion-manufacturer-repairer"
                       groupName="exclusionManufacturerRepairer"
                       inputId="exclusionManufacturerRepairer"
                       label="exclusion manufacturer / repairer"
                       [disabled]="!canEdit()"
      />
    </div>
    <div class="override-cell flex flex-col gap-2">
      <albert-checkbox *albertIfCategory="'includeCutThroughClause'; config: visibility"
                       controlName="includeCutThroughClause"
                       data-test="certificate-final-provisions-include-cut-through-clause"
                       groupName="includeCutThroughClause"
                       inputId="includeCutThroughClause"
                       label="include Cut Through Clause"
                       [disabled]="!canEdit()"
      />
      <albert-checkbox *albertIfCategory="'includeBrokerLetterOfUndertaking'; config: visibility"
                       controlName="includeBrokerLetterOfUndertaking"
                       data-test="certificate-final-provisions-include-broker-letter-of-undertaking"
                       groupName="includeBrokerLetterOfUndertaking"
                       inputId="includeBrokerLetterOfUndertaking"
                       label="include Broker Letter of Undertaking"
                       [disabled]="!canEdit()"
      />
      <albert-checkbox *albertIfCategory="'includeInsurerSplit'; config: visibility"
                       controlName="includeInsurerSplit"
                       data-test="certificate-final-provisions-include-insurer-split"
                       groupName="includeInsurerSplit"
                       inputId="includeInsurerSplit"
                       label="include Insurer Split"
                       [disabled]="!canEdit()"
      />
    </div>
  </div>

</div>
